export default __webpack_public_path__ + "static/card-4-b740ae837c0ef435d3f88ccd9a54df55.png";